import { render, staticRenderFns } from "./InfluencerDetail.vue?vue&type=template&id=4daadf65&scoped=true&"
import script from "./InfluencerDetail.vue?vue&type=script&lang=js&"
export * from "./InfluencerDetail.vue?vue&type=script&lang=js&"
import style0 from "./InfluencerDetail.vue?vue&type=style&index=0&id=4daadf65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4daadf65",
  null
  
)

export default component.exports